
import Close from "../../../assets/filled/Close.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloseIcon({ className, dataTestid = "CloseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Close data-testid={dataTestid} className={classes} {...rest} />
  );
}
